<template>
  <div class="container">
    <div class="main-content-text">
      <span class="update">Last updated: June 2025</span>
      <h1 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Terms and Conditions</h1>
      <p>
        Welcome to www.mycelebrity.in, operated by MyCelebrity by Digitalentio (“Company”, “we”, “our”, or “us”). By accessing our website or engaging with our services, you agree to be bound by the following Terms and Conditions. If you do not agree, please do not use our services.
      </p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">1. Services Offered</h3>
      <p>We offer branding and marketing services including but not limited to:</p>
      <ul>
        <li>Celebrity and influencer campaigns</li>
        <li>Social media marketing and management</li>
        <li>Ad shoots, TV commercials, and multiplex ads</li>
        <li>Event and inauguration planning</li>
        <li>PR articles and media placements</li>
        <li>Verified badge assistance for Instagram, Facebook, and WhatsApp</li>
      </ul>
      <p>All services are subject to separate agreements, timelines, and payment terms, which will be communicated during onboarding.</p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">2. Client Responsibilities</h3>
      <ul>
        <li>Provide accurate information and necessary brand materials</li>
        <li>Approve creatives, scripts, or talent within the agreed timeline</li>
        <li>Make payments on time as per the invoice or agreement</li>
        <li>Not misuse or misrepresent our services or the talent involved</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">3. Campaign Changes & Cancellations</h3>
      <ul>
        <li>Any changes to live campaigns must be communicated in writing</li>
        <li>Cancellations made after confirmation may be subject to a fee</li>
        <li>In case of celebrity unavailability (due to health or schedule), alternatives will be suggested or the campaign rescheduled</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">4. Intellectual Property</h3>
      <p>All content (videos, creatives, scripts) created by us remains our property unless otherwise agreed. Clients may use it for specific purposes outlined in the contract.</p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">5. Confidentiality</h3>
      <p>Both parties agree to maintain confidentiality regarding campaign briefs, pricing, contracts, and any sensitive information shared.</p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">6. Limitation of Liability</h3>
      <p>We are not liable for:</p>
      <ul>
        <li>Platform-level issues (Instagram, YouTube outages, etc.)</li>
        <li>Celebrity/influencer opinions or conduct outside the agreed content</li>
        <li>Delays caused by third-party platforms or vendors</li>
      </ul>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">7. Modifications</h3>
      <p>We reserve the right to modify these Terms and Conditions at any time. Continued use of our services after changes constitutes acceptance.</p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">8. Governing Law</h3>
      <p>These Terms are governed by and construed under the laws of India. Any disputes shall be resolved in the courts of Bengaluru, Karnataka.</p>

      <div class="gap-20"></div>

      <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">9. Contact Us</h3>
      <p>
        For questions regarding these Terms, contact: <br />
        📧 <a href="mailto:branding@digitalentio.com">branding@digitalentio.com</a> <br />
        📱 +91 9113229933
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsConditions",
};
</script>

<style lang="scss">
.main-content-text {
  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 15px;
    color: #111;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }

  p {
    color: #687693;
    margin-bottom: 15px;
  }

  ul, ol {
    padding-left: 20px;
    margin-bottom: 20px;

    li {
     color: var(--BodyColor);
      margin-bottom: 10px;
    }
  }

  a {
    color: var(--mainColor);
    &:hover {
      text-decoration: underline;
    }
  }

  .update {
    display: block;
    margin-bottom: 30px;
    color: #687693;
  }

  .gap-20 {
    margin-bottom: 30px;
  }
}

/* ✅ Dark mode: all text and markers white */
.dark .main-content-text {
  h1, h2, h3, h4, h5, h6,
  p, li, ul, ol, a, .update {
    color: white !important;
  }

  a {
    color: white !important;
    text-decoration: underline;

    &:hover {
      opacity: 0.85;
    }
  }

  /* fix bullet colors */
  ul, ol {
    list-style: none;
    padding-left: 0;

    li {
      position: relative;
      padding-left: 20px;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        color: white;
      }
    }
  }
}

/* 📱 Responsive */
@media only screen and (max-width: 767px) {
  .main-content-text {
    h3 {
      font-size: 20px;
    }
  }
}
</style>
